
import React from "react";
import {
    LineChart,
    Line,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const InsightsChartSection = ({ chartData = [], loading = false }) => {
    if (loading) {
        return (
            <div style={styles.chartBox}>
                <div style={{ height: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <p>Loading chart data...</p>
                </div>
            </div>
        );
    }

    if (!chartData || chartData.length === 0) {
        return (
            <div style={styles.chartBox}>
                <div style={{ height: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <p>No data available Currently </p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            {/* Orders Chart - Left */}
            <div style={styles.chartBox}>
                <h3 style={styles.title}>Orders Overview — Last 7 Days</h3>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="day" />
                        <YAxis />
                        <Tooltip formatter={(value) => value} />
                        <Line
                            type="monotone"
                            dataKey="orders"
                            stroke="#DC2626"
                            strokeWidth={3}
                            dot={{ r: 4, fill: "#DC2626" }}
                            activeDot={{ r: 6 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>

            {/* Revenue Chart - Right */}
            <div style={styles.chartBox}>
                <h3 style={styles.title}>Revenue Overview — Last 7 Days</h3>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="day" />
                        <YAxis />
                        <Tooltip formatter={(value) => `₹ ${value.toLocaleString()}`} />
                        <Bar
                            dataKey="revenue"
                            fill="#16A34A"
                            radius={[4, 4, 0, 0]}
                            minPointSize={1}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: "grid",
        gridTemplateColumns: window.innerWidth < 769 ? " " : "1fr 1fr",
        gap: "20px",
        width: "100%",
    },
    chartBox: {
        background: "#fff",
        padding: "20px",
        borderRadius: "14px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
    },
    title: {
        fontSize: "16px",
        fontWeight: "600",
        margin: "0 0 15px 0",
        color: "#333",
    },
};

// Responsive styles for mobile
const responsiveStyles = `
    @media (max-width: 768px) {
        .insights-charts-container {
            grid-template-columns: 1fr !important;
            gap: 15px !important;
        }
    }
`;

// Add the responsive styles to the document
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = responsiveStyles;
    document.head.appendChild(styleSheet);
}

export default InsightsChartSection;